// @flow

import React from 'react';
import styles from './textArea.scss';

import { convertToRegex } from '../../../../services/helpers';

type Props = {
  name?: string,
  label?: string,
  rows?: number,
  cols?: number,
  placeholder?: string,
  onChange: Function,
  value?: string,
  disabled?: any,
  onBlur?: Function,
  onKeyPress?: Function,
  maxLength?: string,
  inputClassName?: string,
  disabledClass?: any,
  allowedInputKeys?: string, // This prop is to block user from typing wrong input - run time
  textAreaWrapperClass?: string,
  minValue?: string
};

type State = {
  value: string
};

class TextArea extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.state = {
      value: this.props.value || ''
    };
    this.allowedInputKeysRegex = convertToRegex(this.props.allowedInputKeys);
  }

  componentWillReceiveProps(nextProps: Object) {
    if (nextProps && this.props.value !== nextProps.value) {
      this.setState({
        value: nextProps.value
      });
    }
  }

  shouldComponentUpdate(nextProps: Object, nextState: Object) {
    let propsUpdated = true;
    let stateUpdated = true;
    if (nextProps) {
      if (
        nextProps.name === this.props.name &&
        nextProps.label === this.props.label &&
        nextProps.placeholder === this.props.placeholder &&
        nextProps.value === this.props.value &&
        nextProps.disabled === this.props.disabled &&
        nextProps.maxLength === this.props.maxLength &&
        nextProps.inputClassName === this.props.inputClassName &&
        nextProps.disabledClass === this.props.disabledClass &&
        nextProps.allowedInputKeys === this.props.allowedInputKeys
      ) {
        propsUpdated = false;
      }
    }
    if (nextState) {
      if (nextState.value === this.state.value) {
        stateUpdated = false;
      }
    }
    return propsUpdated || stateUpdated;
  }

  onChangeHandler(e) {
    this.setState(
      {
        value: e.target.value
      },
      () => {
        this.props.onChange(this.state.value);
      }
    );
  }

  onBlurHandler(val: any) {
    if (this.props.onBlur) {
      this.props.onBlur(val);
    }
  }

  onKeyPressHandler(event: any) {
    if (this.props.onKeyPress) {
      this.props.onKeyPress(event);
    }
  }

  render() {
    return (
      <div
        className={`textarea-wrappper ${this.props.textAreaWrapperClass || ''}`}
      >
        {this.props.label ? (
          <div className={` ${styles.inputLabel} input-label `}>
            {this.props.label}
          </div>
        ) : null}
        <textarea
          className={` ${styles.inputField} ${
            this.props.disabled ? styles[this.props.disabledClass] : ''
          } input-field ${this.props.inputClassName}`}
          name={this.props.name}
          rows={this.props.rows}
          cols={this.props.cols}
          placeholder={this.props.placeholder}
          value={this.state.value}
          disabled={this.props.disabled || false}
          onChange={e => this.onChangeHandler(e)}
          onBlur={event => this.onBlurHandler(event.target.value)}
          maxLength={this.props.maxLength}
          min={this.props.minValue}
          onKeyPress={event => this.onKeyPressHandler(event)}
        />
      </div>
    );
  }
}

export default TextArea;
